var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdsManager(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 17,
    viewBox: "0 0 25 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_192_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.70343 11.148C2.70343 12.1198 2.91295 12.8659 3.1867 13.3173C3.54568 13.9085 4.08097 14.1589 4.62682 14.1589C5.33082 14.1589 5.97487 13.981 7.21593 12.233C8.21027 10.8321 9.38191 8.86545 10.1702 7.6326L11.5052 5.54389C12.4326 4.09332 13.5059 2.48081 14.7367 1.38774C15.7412 0.495585 16.8251 0 17.9158 0C19.7471 0 21.4915 1.08064 22.8265 3.10742C24.2876 5.32706 24.9968 8.12292 24.9968 11.0081C24.9968 12.7234 24.6649 13.9836 24.0999 14.9794C23.5541 15.9423 22.4902 16.9044 20.7007 16.9044V14.1589C22.233 14.1589 22.6154 12.7251 22.6154 11.0843C22.6154 8.74605 22.08 6.15102 20.9006 4.29692C20.0636 2.98166 18.9789 2.17809 17.7856 2.17809C16.4949 2.17809 15.4563 3.16926 14.289 4.93686C13.6685 5.87584 13.0314 7.0202 12.3161 8.31141L11.5287 9.73195C9.94679 12.588 9.54613 13.2384 8.75524 14.312C7.36891 16.192 6.18526 16.9044 4.62682 16.9044C2.77822 16.9044 1.60912 16.0892 0.8852 14.8608C0.294156 13.8598 0.00390625 12.5464 0.00390625 11.0498L2.70343 11.148Z",
    fill: "#0081FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.13281 3.30118C3.37055 1.35861 5.15657 0 7.20511 0C8.39159 0 9.57094 0.357597 10.8025 1.38157C12.1496 2.50109 13.5854 4.34464 15.3767 7.38307L16.0191 8.47336C17.5696 11.1038 18.4517 12.4569 18.968 13.0952C19.6321 13.9146 20.0971 14.1589 20.7011 14.1589C22.2334 14.1589 22.6158 12.7251 22.6158 11.0843L24.9972 11.0081C24.9972 12.7234 24.6653 13.9836 24.1003 14.9794C23.5545 15.9423 22.4906 16.9044 20.7011 16.9044C19.5886 16.9044 18.603 16.6583 17.5131 15.6113C16.6753 14.8077 15.6958 13.3801 14.9422 12.0967L12.7006 8.28397C11.576 6.37053 10.5443 4.94392 9.9473 4.29772C9.3051 3.60301 8.47935 2.76394 7.16176 2.76394C6.09536 2.76394 5.18966 3.52606 4.43177 4.6916L2.13281 3.30118Z",
    fill: "url(#paint0_linear_192_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.16125 2.76394C6.09486 2.76394 5.18916 3.52606 4.43127 4.6916C3.35969 6.33871 2.70343 8.79198 2.70343 11.148C2.70343 12.1198 2.91295 12.8659 3.1867 13.3173L0.8852 14.8608C0.294156 13.8598 0.00390625 12.5464 0.00390625 11.0498C0.00390625 8.32821 0.737488 5.4917 2.13241 3.30118C3.37014 1.35861 5.15616 0 7.2047 0L7.16125 2.76394Z",
    fill: "url(#paint1_linear_192_2)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_192_2",
    x1: 319.445,
    y1: 945.529,
    x2: 2038.44,
    y2: 1030.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0064E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#0064E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#0073EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0082FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_192_2",
    x1: 391.115,
    y1: 1230.21,
    x2: 391.115,
    y2: 584.133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0082FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064E0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_192_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdsManager);
export default __webpack_public_path__ + "static/media/ads-manager.a3dd9763eaa6eb93605bdd3fd1426087.svg";
export { ForwardRef as ReactComponent };